import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main
      className="min-h-screen flex flex-col items-center justify-center px-4 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #071A2E 0%, #0D2B4A 60%, #071A2E 100%)" }}
    >
      {/* Gold glow orbs */}
      <div
        className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[300px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(ellipse, rgba(201,168,76,0.12) 0%, transparent 70%)" }}
      />
      <div
        className="absolute bottom-0 left-1/4 translate-y-1/2 w-64 h-64 rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(201,168,76,0.07) 0%, transparent 70%)" }}
      />

      {/* Gold top line */}
      <div
        className="absolute top-0 left-0 right-0 h-[2px]"
        style={{ background: "linear-gradient(90deg, transparent, #C9A84C 30%, #E2C27A 50%, #C9A84C 70%, transparent)" }}
      />

      {/* Big 404 watermark */}
      <p
        className="absolute select-none pointer-events-none font-black text-white/[0.03]"
        style={{ fontSize: "clamp(160px, 28vw, 320px)", fontFamily: "'Playfair Display', serif", lineHeight: 1 }}
      >
        404
      </p>

      {/* Content */}
      <div className="relative z-10 text-center max-w-lg">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-10">
          <div
            className="w-10 h-10 flex items-center justify-center rounded-lg border border-[#C9A84C]/40"
            style={{ background: "rgba(201,168,76,0.12)", boxShadow: "0 0 20px rgba(201,168,76,0.18)" }}
          >
            <i className="ri-home-4-fill text-[#C9A84C] text-lg leading-none" />
          </div>
          <div className="text-left">
            <span
              className="font-bold text-sm tracking-[0.1em] uppercase text-white block leading-none"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Thorpe Dellow
            </span>
            <span className="text-[9px] tracking-[0.2em] uppercase text-[#C9A84C]/70 block mt-0.5">
              Structured Investments
            </span>
          </div>
        </div>

        <div
          className="inline-flex items-center gap-2 bg-[#C9A84C]/12 border border-[#C9A84C]/30 text-[#C9A84C] text-[10px] font-bold uppercase tracking-[0.2em] px-4 py-1.5 rounded-full mb-6"
        >
          <i className="ri-error-warning-line text-xs leading-none" />
          Page Not Found
        </div>

        <h1
          className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          This Page
          <br />
          <span style={{ color: "#C9A84C" }}>Doesn&apos;t Exist</span>
        </h1>

        <p className="text-slate-400 text-sm leading-relaxed mb-10 max-w-sm mx-auto">
          The page you&apos;re looking for may have been moved, renamed, or is no longer available. Please use the navigation below to find what you need.
        </p>

        {/* Quick links */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-bold text-sm cursor-pointer whitespace-nowrap transition-all hover:brightness-110"
            style={{ background: "linear-gradient(135deg, #C9A84C 0%, #E2C27A 50%, #C9A84C 100%)", color: "#071A2E" }}
          >
            <i className="ri-home-4-line leading-none" />
            Return Home
          </Link>
          <Link
            to="/social-housing"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-white/20 text-white font-semibold text-sm hover:bg-white/8 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-text-line leading-none" />
            Investment Product
          </Link>
        </div>

        {/* Page shortcuts */}
        <div className="flex flex-wrap justify-center gap-2">
          {[
            { label: "Properties", path: "/properties" },
            { label: "About Us", path: "/about" },
            { label: "Contact", path: "/contact" },
          ].map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className="px-4 py-2 rounded-lg text-[11px] font-medium text-slate-500 hover:text-[#C9A84C] border border-white/8 hover:border-[#C9A84C]/30 transition-all cursor-pointer whitespace-nowrap"
            >
              {l.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Bottom line */}
      <div
        className="absolute bottom-0 left-0 right-0 h-[1px]"
        style={{ background: "linear-gradient(90deg, transparent, rgba(201,168,76,0.25) 40%, rgba(201,168,76,0.25) 60%, transparent)" }}
      />
    </main>
  );
}
